var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25F4EE",
    d: "M11.77 12.33v-1.22a9 9 0 0 0-1.28-.11 9.49 9.49 0 0 0-5.44 17.28 9.48 9.48 0 0 1 6.72-15.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25F4EE",
    d: "M12 26.15A4.34 4.34 0 0 0 16.33 22V1.31h3.78A7 7 0 0 1 20 0h-5.17v20.67a4.34 4.34 0 0 1-4.33 4.18 4.4 4.4 0 0 1-2-.5 4.34 4.34 0 0 0 3.5 1.8M27.17 8.33V7.18A7.06 7.06 0 0 1 23.26 6a7.17 7.17 0 0 0 3.91 2.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2C55",
    d: "M23.26 6a7.12 7.12 0 0 1-1.77-4.7h-1.38A7.16 7.16 0 0 0 23.26 6M10.49 16.17a4.34 4.34 0 0 0-2 8.18A4.33 4.33 0 0 1 12 17.48a4.6 4.6 0 0 1 1.28.2v-5.26a9 9 0 0 0-1.28-.1h-.23v4a4.5 4.5 0 0 0-1.28-.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2C55",
    d: "M27.17 8.33v4A12.27 12.27 0 0 1 20 10v10.51A9.51 9.51 0 0 1 10.49 30a9.4 9.4 0 0 1-5.44-1.72 9.49 9.49 0 0 0 16.44-6.46V11.34a12.3 12.3 0 0 0 7.18 2.3V8.49a7.3 7.3 0 0 1-1.5-.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20.51V10a12.27 12.27 0 0 0 7.18 2.3v-4A7.17 7.17 0 0 1 23.26 6a7.16 7.16 0 0 1-3.15-4.7h-3.78V22a4.34 4.34 0 0 1-7.85 2.37 4.34 4.34 0 0 1 2-8.18 4.5 4.5 0 0 1 1.28.2v-4a9.48 9.48 0 0 0-6.72 16A9.4 9.4 0 0 0 10.49 30 9.51 9.51 0 0 0 20 20.51"
  }))));
};
export default SvgTiktok;